import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import amstelLogo from '@/assets/landing/images/companies/amstel.svg';
import maxLogo from '@/assets/landing/images/companies/max.svg';
import eletroluxLogo from '@/assets/landing/images/companies/eletrolux.svg';
import audibleLogo from '@/assets/landing/images/companies/audible.svg';
import testimonialsCover from '@/assets/landing/images/testimonials-cover.png';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function TestimonialSection() {
  const testimonials = [
    {
      quote:
        'O Culture Monitor é uma janela para as principais tendências e conversas que acontecem no mundo digital… um momento de inspiração diária! [...] Nos tornamos mais relevantes para aqueles que acompanham nossas redes.',
      author: 'Caio Borelli Lizá',
      position: 'Marketing Futebol - Amstel',
      logo: amstelLogo
    },
    {
      quote:
        'O Culture Monitor foi fundamental durante um período desafiador para conectar nossa marca com o público de futebol. Alcançamos resultados incríveis com peças orgânicas, ágeis e inovadoras.',
      author: 'Thiago Santos',
      position: 'Gerente de Social Media Brasil - Max',
      logo: maxLogo
    },
    {
      quote:
        'Durante o BBB, usamos o Culture Monitor para entender os assuntos e decidir como e quando participar. Aproximou a Electrolux dos consumidores e revelou uma comunidade de brandlovers com impacto real.',
      author: 'Thiago Giamarino',
      position: 'Gerente Sr de Mídia e Ativação - Electrolux',
      logo: eletroluxLogo
    },
    {
      quote:
        'O Culture Monitor sempre traz drops culturais que consolidam o que observamos nas redes e entregam oportunidades práticas e rápidas de aplicação.',
      author: 'Ian Scabia',
      position: 'Brand and Content Marketing Manager - Audible',
      logo: audibleLogo
    }
  ];

  return (
    <section className="relative py-24 bg-[#f9f9f9]">
      <div
        className="hidden md:block absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url(${testimonialsCover})`,
          backgroundSize: '100% auto',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%'
        }}
      ></div>
      <div className="landing-container relative z-10">
        <div className="max-w-4xl mx-auto text-center relative">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            navigation={{
              nextEl: '.swiper-button-next-custom',
              prevEl: '.swiper-button-prev-custom'
            }}
            pagination={{
              clickable: true,
              bulletClass: 'swiper-pagination-bullet-custom',
              bulletActiveClass: 'swiper-pagination-bullet-active-custom'
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false
            }}
            loop
            className="testimonial-swiper"
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="px-8 py-12">
                  <blockquote className="text-xl text-gray-700 leading-relaxed mb-8">{testimonial.quote}</blockquote>
                  <div className="flex items-center justify-center space-x-4">
                    <img src={testimonial.logo} alt="Company Logo" className="w-14 h-14" />
                    <div className="text-left">
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-gray-600">{testimonial.position}</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="hidden md:flex justify-between items-center absolute inset-0 pointer-events-none z-20">
          <button className="swiper-button-prev-custom w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-all duration-200 pointer-events-auto z-30">
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <button className="swiper-button-next-custom w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-all duration-200 pointer-events-auto z-30">
            <ArrowRight className="w-5 h-5 text-gray-600" />
          </button>
        </div>
        <div className="flex justify-end items-end absolute bottom-4 right-4 pointer-events-none md:hidden z-20">
          <div className="flex space-x-2">
            <button className="swiper-button-prev-custom w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-all duration-200 pointer-events-auto z-30">
              <ArrowLeft className="w-4 h-4 text-gray-600" />
            </button>
            <button className="swiper-button-next-custom w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-all duration-200 pointer-events-auto z-30">
              <ArrowRight className="w-4 h-4 text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

